import FileUploadFormBlock from 'models/common/form/FileUploadFormBlock';

export default class FileUploadFormBlockService {
	toModel(formBlock) {
		return new FileUploadFormBlock(formBlock);
	}
}
